import { QueryClient, hashKey } from '@tanstack/react-query';
import { client } from './client/client.gen';
let _getSessionContext;
export const configureClient = ({ baseUrl, getSessionContext: getter }) => {
    _getSessionContext = getter;
    client.setConfig({
        baseUrl,
        credentials: 'include',
    });
    client.interceptors.request.use((request) => {
        const ctx = _getSessionContext?.();
        if (ctx) {
            request.headers.set('Platform-Id', ctx.platformId);
            request.headers.set('Live-Mode', ctx.liveMode ? 'Yes' : 'No');
        }
        return request;
    });
};
export const createColumnQueryClient = (options) => new QueryClient({
    ...options,
    defaultOptions: {
        ...options?.defaultOptions,
        queries: {
            ...options?.defaultOptions?.queries,
            queryKeyHashFn: (queryKey) => {
                const ctx = _getSessionContext?.();
                return hashKey([...queryKey, ctx?.platformId, ctx?.liveMode]);
            },
        },
    },
});
//# sourceMappingURL=configure.js.map